import { render, staticRenderFns } from "./index-page.vue?vue&type=template&id=12eb6a8f&scoped=true&"
import script from "./index-page.vue?vue&type=script&lang=js&"
export * from "./index-page.vue?vue&type=script&lang=js&"
import style0 from "./index-page.vue?vue&type=style&index=0&id=12eb6a8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12eb6a8f",
  null
  
)

export default component.exports